import { Button, ButtonGroup, Callout, Collapse, Icon, Intent, Popover, Tag, Tooltip } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled, {css} from "styled-components";

import { FlexJustify } from "common/fragments/Flex";
import * as configActions from "core/actions/configActions";
import { useState } from "react";
import React from "react";
import CarouselConfig from "../../../common/views/carousel/CarouselConfig";

const StatsContainer = styled.div<{padding: boolean}>(({padding}) => css`
	${padding && css`
		padding: 15px;
	`};
	min-width: 420px;

	& .bp3-callout {
		margin-bottom: 10px;
	}

	& .heading {
		font-size: 18px;
		font-weight: bold;
		margin: 10px 0;
		display: block;
		color: inherit;
		padding: 0;

		&.hover {
			cursor: pointer;
		}

		&.hover:active, &.hover:hover {
			margin: 5px -5px;
			padding: 5px;
		}

		&.hover:hover {
			background: rgba(0, 0, 0, 0.2);
		}

		&.hover:active {
			background: rgba(0, 0, 0, 0.4);
		}
	}

	& > table {
		width: 100%;
	}

	& > table td {
		padding: 3px;

		&:first-child {
			padding-left: 0;
		}

		&:nth-child(2) {
			padding-right: 15px;
			text-align: right;
		}

		&:last-child {
			padding-right: 0;
			text-align: right;
		}
	}
`);

const SystemHealth: React.SFC<{padding?: boolean, expandedDefault?: boolean}> = ({padding = true, expandedDefault = false}) => {
	const [registryStats, setRegistryStats] = useState(expandedDefault);

	return (
		<StatsContainer padding={padding}>
			<Callout icon={IconNames.TICK} title="System healthy" intent={Intent.SUCCESS}>
				No issues detected. Error rate is acceptable.
			</Callout>

			<table>
				<tr>
					<td colSpan={4}>
						<FlexJustify>
							<div className="heading">Live Stats</div>
							<Tooltip content="Detailed stats and charts" usePortal={false}>
								<Button minimal={true} icon={IconNames.CHART} intent={Intent.PRIMARY} />
							</Tooltip>
						</FlexJustify>
					</td>
				</tr>
				<tr>
					<td>Active queries</td>
					<td>
						<Tag intent={Intent.PRIMARY}>4</Tag>
					</td>
					<td>JS errors caught </td>
					<td>
						<Tag intent={Intent.DANGER}>3</Tag>
					</td>
				</tr>
				<tr>
					<td>Preloaded queries</td>
					<td>
						<Tag intent={Intent.NONE}>3</Tag>
					</td>
					<td>API errors observed </td>
					<td>
						<Tag intent={Intent.DANGER}>9</Tag>
					</td>
				</tr>
				<tr>
					<td>Resolver cache hit</td>
					<td>
						<Tag intent={Intent.WARNING}>30%</Tag>
					</td>
					<td>Errors sent to sentry </td>
					<td>
						<Tag intent={Intent.NONE}>0</Tag>
					</td>
				</tr>
				<tr>
					<td colSpan={4} onClick={() => setRegistryStats(!registryStats)}>
						<div className="heading hover">
							<FlexJustify>
								Registry
								<Icon icon={registryStats ? IconNames.CHEVRON_DOWN : IconNames.CHEVRON_LEFT} />
							</FlexJustify>
						</div>
					</td>
				</tr>
				{registryStats && (
					<React.Fragment>
						<tr>
							<td>Panels</td>
							<td>
								<Tag intent={Intent.NONE}>27</Tag>
							</td>
							<td>PropertyTypes</td>
							<td>
								<Tag intent={Intent.NONE}>4</Tag>
							</td>
						</tr>
						<tr>
							<td>Views</td>
							<td>
								<Tag intent={Intent.NONE}>19</Tag>
							</td>
							<td>Services</td>
							<td>
								<Tag intent={Intent.NONE}>9</Tag>
							</td>

						</tr>
						<tr>
							<td>Total objects</td>
							<td>
								<Tag intent={Intent.PRIMARY}>127</Tag>
							</td>
							<td></td>
							<td></td>
						</tr>
					</React.Fragment>
				)}
			</table>
		</StatsContainer>
	);
};

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = (dispatch) => {
	return { actions: bindActionCreators(configActions as any, dispatch) };
};

export default connect<void>(mapStateToProps, mapDispatchToProps)(SystemHealth);





























































































































// WEBPACK FOOTER //
// ./src/core/components/editor/SystemHealth.tsx